"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ListItemSecondaryAction = _interopRequireDefault(require("../ListItemSecondaryAction"));
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var useStyles = (0, _styles.makeStyles)({
  root: {
    right: 8
  }
});
var handleEventOff = function handleEventOff(e) {
  e.stopPropagation();
  e.preventDefault();
};
var InputActions = function InputActions(_ref) {
  var children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemSecondaryAction["default"], {
    className: classes.root,
    onClick: handleEventOff,
    onMouseDown: handleEventOff,
    onMouseEnter: handleEventOff,
    onMouseOver: handleEventOff,
    onTouchStart: handleEventOff,
    children: children
  });
};
var _default = exports["default"] = InputActions;